
import React from 'react';

function Awards() {
  return (
    <div className="container mt-5">
      <div className="row align-items-center">

        {/* Image Section */}
        <div className="col-12 col-md-6 p-3 text-center">
          <img
            src="media/largestBroker.svg"
            alt="Awards"
            className="img-fluid"
          />
        </div>

        {/* Content Section */}
        <div className="col-12 col-md-6 p-3">
          <h1 className="text-center text-md-start">
            Largest Broker in India
          </h1>

          <p className="mb-4 text-center text-md-start">
            2+ million customers trust us to manage their investments and grow
            their wealth. Join our community of successful investors and
            experience the benefits of our award-winning platform.
          </p>

          {/* List Section */}
          <div className="row text-center text-md-start">
            <div className="col-12 col-sm-6">
              <ul>
                <li>Futures And Options</li>
                <li>Commodity Derivatives</li>
                <li>Currency Derivatives</li>
              </ul>
            </div>

            <div className="col-12 col-sm-6">
              <ul>
                <li>Stocks & IPOs</li>
                <li>Direct mutual funds</li>
                <li>Bonds and Growth</li>
              </ul>
            </div>
          </div>

          {/* Logos */}
          <div className="text-center text-md-start mt-3">
            <img
              src="media/pressLogos.png"
              alt="Press Logos"
              className="img-fluid"
              style={{ maxWidth: "90%" }}
            />
          </div>
        </div>

      </div>
    </div>
  );
}

export default Awards;